export class PrivacyPolicySitecoreTemplate {

    public PrivacyPolicyText: string;
}